export const CART_UPDATED = "CART_UPDATED"
export const REQUEST_ERROR_MODAL_OPEN = "REQUEST_ERROR_MODAL_OPEN"
export const REQUEST_MAP_MODAL_OPEN = "REQUEST_MAP_MODAL_OPEN"
export const REQUEST_CONTENT_MODAL_OPEN = "REQUEST_CONTENT_MODAL_OPEN"
export const REQUEST_DESTINATION_MODAL_OPEN = "REQUEST_DESTINATION_MODAL_OPEN"
export const REQUEST_QA_MODAL_OPEN = "REQUEST_QA_MODAL_OPEN"
export const SEARCH_FACETS_UPDATED = "SEARCH_FACETS_UPDATED"
export const SEARCH_FILTER_ACTIVATED = "SEARCH_FILTER_ACTIVATED"
export const SEARCH_FILTER_DEACTIVATED = "SEARCH_FILTER_DEACTIVATED"
export const SEARCH_ACTIVATED = "SEARCH_ACTIVATED"
export const DESTINATION_UPDATED = "DESTINATION_UPDATED"
export const COUPON_UPDATED = "COUPON_UPDATED"
export const REQUEST_MERCHANT_CONTACT_MODAL = "REQUEST_MERCHANT_CONTACT_MODAL"
export const REQUEST_ITINERARY_SIGNUP_MODAL = "REQUEST_ITINERARY_SIGNUP_MODAL"
export const REQUEST_FOLLOW_FLIGHT_COMPONENT = "REQUEST_FOLLOW_FLIGHT_COMPONENT"
export const REQUEST_FLIGHT_SIGNUP_MODAL = "REQUEST_FLIGHT_SIGNUP_MODAL"
